import React from 'react';

import { ModelBase } from "@models";

import DataUtilities from "@dndUtilities/data_utilities";

import ImageButtonBox from "@components/input/buttons/ImageButtonBox";
import ButtonBox from "@components/input/buttons/ButtonBox";

interface Props {
  obj: ModelBase;
  display_format?: string;
  show_image?: boolean;
  string_limit?: number;
  disabled?: boolean;
  width?: number;
  style?: React.CSSProperties | undefined;
  className?: string;
  flashing?: boolean;
  small?: boolean;
  onClick?: ((event: React.MouseEvent<HTMLDivElement>) => void) | null; 
}

const data_util = DataUtilities.getInstance();

export default function ObjectButtonBox({ 
  obj,
  display_format = "{obj.true_name}",
  show_image = false,
  string_limit = 20,
  disabled = false,
  width = -1,
  style = {},
  className = "",
  flashing = false,
  small = false,
  onClick = null,
}: Props) {
  let text = data_util.getStringWithReplacements3({ clean_me: display_format, backup: display_format, obj });
  if (text.length > string_limit) {
    text = text.substring(0, string_limit) + "...";
  }

  if (show_image) {
    return (
      <ImageButtonBox
        name={text}
        image_url={obj.image_url}
        disabled={disabled}
        small={small}
        style={style}
        width={width}
        className={className}
        flashing={flashing}
        onClick={onClick}
      />
    );
  } else {
    return (
      <ButtonBox
        name={text}
        disabled={disabled}
        small={small}
        style={style}
        width={width}
        className={className}
        flashing={flashing}
        onClick={onClick}
      />
    );
  }
}
